import React, { FunctionComponent, useContext } from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { ViewAssetButton } from "../../../../../common/components/ViewAssetButton";
import { TvSeriesDashboardContext } from "../../../../TvSeriesDashboardProvider";
import { TvSeriesContext } from "../../../context/TvSeriesContext";
import { EpisodeVersionListingItem } from "../EpisodeVersionListingItem";

export const ViewEpisodeVersionAssetButton: FunctionComponent<ListActionButtonProps<EpisodeVersionListingItem>> = (
    props: ListActionButtonProps<EpisodeVersionListingItem>
) => {
    const { moveToTvSeriesAssets } = useContext(TvSeriesContext);
    const { selectedSeason, selectedEpisode } = useContext(TvSeriesDashboardContext);

    const handleClick = () => {
        moveToTvSeriesAssets(selectedSeason?.id, selectedEpisode?.id, props.item.versionTypeId);
    };

    return <ViewAssetButton disabled={props.disabled} onClick={handleClick} />;
};
